module.exports = __webpack_public_path__ + "static/media/disease-views-under-development-02.4c831ca5.png";